import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format } from "date-fns";
import { memo } from "react";
import { WorkspaceTaskGroupRow } from "../workspaceTaskGroupsViewConfig";

export const TaskGroupUpdatedCell = memo(
    ({ row }: CellContext<ViewTableFeatures, WorkspaceTaskGroupRow, Date>) => (
        <span>{format(row.original.updatedAt, "MMM d, yyyy")}</span>
    ),
);
